var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mobiTitle white lg content",attrs:{"id":"contentTitle"}},[_vm._v("\n    "+_vm._s(_vm.$t('contact'))+"\n  ")]),_vm._v(" "),(_vm.country_name_fplus == 'greece' && _vm.gateway_code =='mobivas')?_c('span',[_c('contact-paydash-greek')],1):_c('span',[_c('contact')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c328064a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/funplus/Contact.vue
// module id = 1915
// module chunks = 0